import type { ACCESSAlignmentResultCode } from '@/types/registration';
import type { WregStep } from './wregSteps';

const WREG_ALIGN_STEP: Record<ACCESSAlignmentResultCode, WregStep> = {
  aligned: 'allset',
  'aligned-switch-approved': 'allset',
  'not-aligned-control-group': 'x-control',
  'not-aligned-already-aligned': 'x-already',
  'not-aligned-no-switch-attestation': 'switch',
  'not-aligned-not-medicare': 'x-notelig',
  'not-aligned-services': 'x-notelig',
  'not-aligned-diagnoses': 'x-noqualify',
  'not-aligned-clinical-exclusion': 'x-notelig',
  'not-aligned-mismatch': 'x-mismatch',
};

const WREG_ALIGN_CODES = Object.keys(WREG_ALIGN_STEP) as ACCESSAlignmentResultCode[];

const WREG_ALIGN_FALLBACK_STEP: WregStep = 'x-error';

const ALIGN_NOTELIG_BODY: Partial<Record<ACCESSAlignmentResultCode, string>> = {
  'not-aligned-not-medicare': 'wreg.x.notelig.medicare',
  'not-aligned-services': 'wreg.x.notelig.services',
};

const ALIGN_NOTELIG_FALLBACK_BODY = 'wreg.x.notelig.clinical';

const isWregAlignCode = (code: string): code is ACCESSAlignmentResultCode =>
  Object.prototype.hasOwnProperty.call(WREG_ALIGN_STEP, code);

const wregAlignStep = (code: string | undefined): WregStep => {
  if (code !== undefined && isWregAlignCode(code)) return WREG_ALIGN_STEP[code];
  console.warn(
    `wreg: unrecognised alignment result code "${code}", showing ${WREG_ALIGN_FALLBACK_STEP}`,
  );
  return WREG_ALIGN_FALLBACK_STEP;
};

const wregAlignNoteligBodyKey = (code: string | undefined): string =>
  (code !== undefined && isWregAlignCode(code) ? ALIGN_NOTELIG_BODY[code] : undefined) ??
  ALIGN_NOTELIG_FALLBACK_BODY;

const wregAlignEnrolled = (code: string | undefined): boolean =>
  code === 'aligned' || code === 'aligned-switch-approved';

const wregAlignNeedsAttestation = (code: string | undefined): boolean =>
  code === 'not-aligned-no-switch-attestation';

export {
  ALIGN_NOTELIG_FALLBACK_BODY,
  WREG_ALIGN_CODES,
  WREG_ALIGN_FALLBACK_STEP,
  WREG_ALIGN_STEP,
  isWregAlignCode,
  wregAlignEnrolled,
  wregAlignNeedsAttestation,
  wregAlignNoteligBodyKey,
  wregAlignStep,
};
